<template>
  <div class="page">
    <div class="page-bd">
      <div class="panel" @click="toggleClick">
        <div class="box">
          <div class="box-hd">
            <img src="https://img.shengdeduo.com.cn/upload/goods/20200820/1597904468381.jpg/b200" />
          </div>
          <div class="box-bd">
            <div class="box-bd__content">
              <div class="box-bd__panel">
                <div class="box-bd__panel__title">
                  <div class="box-bd__title">【新人专享】</div>
                  <div class="box-bd__subtitle">叶盐 精制加碘食用盐 400克/袋 惊爆价0.01元</div>
                </div>
                <div class="box-bd__flex">
                  <div class="box-bd__flex__text">
                    <small>¥</small>0.01元
                  </div>
                  <div class="box-bd__flex__btn">立即抢购</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-hd">
            <img src="https://img.shengdeduo.com.cn/upload/goods/20200726/1595764585415.jpg/b200" />
          </div>
          <div class="box-bd">
            <div class="box-bd__content">
              <div class="box-bd__panel">
                <div class="box-bd__panel__title">
                  <div class="box-bd__title">【新人专享】</div>
                  <div class="box-bd__subtitle">OUSU欧素 竹炭吸附牙刷 新人价0.19元/支</div>
                </div>
                <div class="box-bd__flex">
                  <div class="box-bd__flex__text">
                    <small>¥</small>0.19元
                  </div>
                  <div class="box-bd__flex__btn">立即抢购</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-hd">
            <img src="https://img.shengdeduo.com.cn/upload/goods/20200827/1598517663664.jpg/b200" />
          </div>
          <div class="box-bd">
            <div class="box-bd__content">
              <div class="box-bd__panel">
                <div class="box-bd__panel__title">
                  <div class="box-bd__title">【新人专享】</div>
                  <div class="box-bd__subtitle">可口可乐瓶装 500ml/瓶 新人价1.69元</div>
                </div>
                <div class="box-bd__flex">
                  <div class="box-bd__flex__text">
                    <small>¥</small>1.69元
                  </div>
                  <div class="box-bd__flex__btn">立即抢购</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-hd">
            <img src="https://img.shengdeduo.com.cn/upload/goods/20200827/1598518826295.jpg/b200" />
          </div>
          <div class="box-bd">
            <div class="box-bd__content">
              <div class="box-bd__panel">
                <div class="box-bd__panel__title">
                  <div class="box-bd__title">【新人专享】</div>
                  <div class="box-bd__subtitle">舒肤佳香皂 108g/盒 新人价2.99元</div>
                </div>
                <div class="box-bd__flex">
                  <div class="box-bd__flex__text">
                    <small>¥</small>2.99元
                  </div>
                  <div class="box-bd__flex__btn">立即抢购</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-hd">
            <img src="https://img.shengdeduo.com.cn/upload/goods/20200724/1595567466601.jpg/b200" />
          </div>
          <div class="box-bd">
            <div class="box-bd__content">
              <div class="box-bd__panel">
                <div class="box-bd__panel__title">
                  <div class="box-bd__title">【秒杀】</div>
                  <div class="box-bd__subtitle">精选红心蜜柚单个2.5斤以上 2个/份 秒杀价：9.9元</div>
                </div>
                <div class="box-bd__flex">
                  <div class="box-bd__flex__text">
                    <small>¥</small>9.9元
                  </div>
                  <div class="box-bd__flex__btn">立即抢购</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <div class="btn-text">查看更多商品</div>
          <div class="btn-icon"></div>
        </div>
        <wx-open-launch-weapp id="launch-btn" username="gh_70e2a8ab58c1" path="/pages/category/index.html?cateId=1000&fromUserId=5db5631e12480ffe683d219041ac3410">
          <!-- 必须写：占位的按钮 -->
          <script type="text/wxtag-template">
          <style>
            .ctn{ width: 414px;height: 779px;}
          </style>
          <div class="ctn"></div>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
    <div class="wechat">
      <img src="../assets/images/hah.png"/>
    </div>
    <div v-if="!hasBtn" class="qrcode">
      <img src="../assets/images/code.jpg" />
      <div class="qrcode-text">长按识别，了解更多低价</div>
    </div>
    <a class="copyright" href="https://beian.miit.gov.cn/" target="_blank">豫ICP备20021520号-1</a>

  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  name: 'haha',
  data () {
    return {
      hasBtn: true
    }
  },
  created () {
    let check = false
    const userAgent = window.navigator.userAgent.toLowerCase()
    const isIPhone = /(iphone|ios)/.test(userAgent)
    const wechat = navigator.userAgent.match(/MicroMessenger\/([\d.]+)/i)
    const isAndroid = /(android)/.test(userAgent)
    if (wechat) {
      if (isIPhone) {
        const judgewechat = wechat[1].split('.')

        if (judgewechat[0] >= 7) {
          if (judgewechat[1] >= 0) {
            if (judgewechat[2] >= 12) {
              check = true
            } else {
              this.hasBtn = false
            }
          } else {
            this.hasBtn = false
          }
        } else {
          this.hasBtn = false
        }
      } else if (isAndroid) {
        check = true
      }
    } else {
      this.hasBtn = false
    }
    if (check) {
      this.$axios.post('share/get_wxshare_config.action', {
        type: 'WX',
        url: location.href.split('#')[0]
      }).then((response) => {
        if (response.data.msgcode === 100) {
          const res = response.data.object || {}
          // eslint-disable-next-line no-undef
          wx.config({
            debug: false,
            appId: 'wxee625da92693d556',
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: ['chooseImage'],
            openTagList: ['wx-open-launch-weapp']
          })
          // eslint-disable-next-line no-undef
          wx.ready(() => {
          })

          // eslint-disable-next-line no-undef
          wx.error((error) => {
            console.log(error)
            this.hasBtn = false
          })
        }
      })
    }
  },
  methods: {
    toggleClick () {
      if (!this.hasBtn) {
        Toast('长按识别小程序，了解更多低价')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.copyright {
  font-size: 14px;
  color: #999;
  text-align: center;
  display: block;
  padding: 20px 0;
}
#launch-btn {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
  top: 0;
  z-index: 1;
  background: transparent;

}
.page {
  background: #fff;
  max-width: 750px;
  margin: 0 auto;
}

.qrcode {
  padding: 50px 0;
  width: 195px;
  margin: 0 auto;
  text-align: center;
}

.page-bd {
  position: relative;
  background: #ed8c3b url("../assets/images/haha.png") no-repeat center top;
  background-size: 100% auto;
  min-height: 100vh;
  padding-top: 96500/750%;
  padding-bottom: 8000/750%;
  overflow-x: hidden;
}
.panel {
  position: relative;
}

.box {
  width: 710/7.5vw;
  margin: 0 auto 11px;
  display: flex;
  &-hd {
    display: flex;
    width: 133px;
    position: relative;
    background: #9f2c25;
    &:after {
      content: "";
      padding-top: 100%;
    }
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
  &-bd {
    flex: 1;
    background: #f4b070;
    display: flex;
    align-items: center;
    justify-content: center;
    &__content {
      width: 397/7.5vw;
      display: flex;
      background: #fff;
      position: relative;
      &:after {
        content: "";
        padding-top: 22200/397%;
      }
    }
    &__panel {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      padding: 2300/397% 24/7.5vw 1900/387% 24/7.5vw;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &__subtitle {
      padding-top: 1300/397%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &__title,
    &__subtitle {
      font-size: 15px;
      line-height: 1;
      color: #3c3c3c;
      font-weight: 500;
    }

    &__flex {
      display: flex;
      align-items: center;
      border-radius: 3px;
      background: -webkit-linear-gradient(left, #ed7345, #ea3f4a);
      padding: 3px 3px 3px 6px;
      &__text {
        font-size: 15px;
        color: #fff;
        font-weight: 500;
        flex: 1;
      }
      &__btn {
        display: flex;
        width: 147/7.5vw;
        border-radius: 3px;
        background: -webkit-linear-gradient(top, #fde466, #ffa200);
        font-size: 13px;
        color: #9f2c25;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        &:after {
          content: "";
          padding-top: 5700/147%;
        }
      }
    }
  }
}

.btn {
  width: 336/7.5vw;
  margin: 26px auto 0;
  display: flex;
  height: 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffe0c3;
  border-radius: 100px;
  &-text {
    font-weight: bold;
    font-size: 15px;
    color: #ffe0c3;
  }
  &-icon {
    margin-left: 7px;
    width: 16px;
    height: 16px;
    background: url("../assets/images/arrow.png") no-repeat center;
    background-size: 100% 100%;
  }
}
.wechat {
  padding-top: 28100/750%;
  position: relative;
  background: #fff;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
